import contentfulPromotionalPlacementsHelper from "utils/contentfulPromotionalPlacements"
import contentfulAdPlacementsHelper from "utils/contentfulAdPlacements"

export const parseArticle = (article, helpers) => {
  if (typeof article.body[0] === "string") {
    const parsedArticle = {
      ...article,
      category: article.category || "Mindfulness",
      body: article.body.map((element) => JSON.parse(element)),
      previewImage: JSON.parse(article.previewImage),
      seo: JSON.parse(article.seo),
      funnel: JSON.parse(article.funnel),
      socialPromotion: JSON.parse(article.socialPromotion),
      instructorClass: JSON.parse(article.instructorClass),
      recipes: article.recipes ? article.recipes.map((recipe) => JSON.parse(recipe)) : null,
      schema: JSON.parse(article.schema),
      recipeSchema: JSON.parse(article.recipeSchema),
      dataLayer: JSON.parse(article.dataLayer),
      featuredVideos: helpers.featuredVideos,
      trustedCitationSources: helpers.trustedCitationSources,
    }

    contentfulAdPlacementsHelper.addToArticle(parsedArticle, helpers.contentfulAdPlacements)
    contentfulPromotionalPlacementsHelper.replacePromotionalPlacements(
      parsedArticle,
      helpers.contentfulPromotionalPlacements,
    )

    return parsedArticle
  }
  return article
}
